(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('PhoneCallPurposeSearch', PhoneCallPurposeSearch);

    PhoneCallPurposeSearch.$inject = ['$resource'];

    function PhoneCallPurposeSearch($resource) {
        var resourceUrl =  'api/_search/phone-call-purposes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
